class Sidebar {
    static hide() {
        document.querySelector('.sidebar-container').classList.remove('active')
    }

    static show() {
        document.querySelector('.sidebar-container').classList.add('active')
    }
}

document.addEventListener('DOMContentLoaded', e => {
    document.querySelector('.navbar-btn-show-sidebar')
        .addEventListener('click', e => Sidebar.show())

    document.querySelector('.sidebar-container')
        .addEventListener('click', e => Sidebar.hide())

    document.querySelector('.sidebar-content')
        .addEventListener('click', e => e.stopPropagation(), false)
}, false);

export default Sidebar
